window.theme = window.theme || {};
window.slideout = false;

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body')
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.drawersInit();
};

timber.drawersInit = function () {
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load,
  });
};

timber.getHash = function () {
  return window.location.hash;
};


/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    //this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        if ($('.collection-mini-carousel-slick')){
          if ($('.collection-mini-carousel-slick').length > 0 ){
            if ($('.collection-mini-carousel-slick.slick-initialized.slick-slider').length <1){
              $('.collection-mini-carousel-slick').slick({
                  accessibility: false,
                  slidesToShow: 2,
                  infinite: false
              });
            }
          }
        }
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    // Run function when draw opens if set
    if (this.config.onDrawerClose && typeof(this.config.onDrawerClose) == 'function') {
        this.config.onDrawerClose(); 
    }

    // Ensure closing transition is applied to moved elements, like the nav
    //this.$nodes.moved.prepareTransition({ disableExisting: true });
    //this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');
    this.$nodes.page.off('.drawer');

    ajaxCart.scrollToTrigger();
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();
// Initialize Timber's JS on docready
$(timber.init);

// Utility for creating objects in older browsers
       if ( typeof Object.create !== 'function' ) {
     Object.create = function( obj ) {

  function F() {}
  F.prototype = obj;
  return new F();

};
} 

// cookie
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function o(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function r(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(c," ")),u.json?JSON.parse(e):e}catch(n){}}function t(n,o){var i=u.raw?n:r(n);return e.isFunction(o)?o(i):i}var c=/\+/g,u=e.cookie=function(r,c,a){if(void 0!==c&&!e.isFunction(c)){if(a=e.extend({},u.defaults,a),"number"==typeof a.expires){var d=a.expires,f=a.expires=new Date;f.setTime(+f+864e5*d)}return document.cookie=[n(r),"=",i(c),a.expires?"; expires="+a.expires.toUTCString():"",a.path?"; path="+a.path:"",a.domain?"; domain="+a.domain:"",a.secure?"; secure":""].join("")}for(var s=r?void 0:{},p=document.cookie?document.cookie.split("; "):[],m=0,v=p.length;v>m;m++){var x=p[m].split("="),k=o(x.shift()),l=x.join("=");if(r&&r===k){s=t(l,c);break}r||void 0===(l=t(l))||(s[k]=l)}return s};u.defaults={},e.removeCookie=function(n,o){return void 0===e.cookie(n)?!1:(e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n))}});
// Placeholder
!function(e,a,t){function l(e){var a={},l=/^jQuery\d+$/;return t.each(e.attributes,function(e,t){t.specified&&!l.test(t.name)&&(a[t.name]=t.value)}),a}function r(e,l){var r=this,o=t(r);if(r.value==o.attr("placeholder")&&o.hasClass("placeholder"))if(o.data("placeholder-password")){if(o=o.hide().next().show().attr("id",o.removeAttr("id").data("placeholder-id")),e===!0)return o[0].value=l;o.focus()}else r.value="",o.removeClass("placeholder"),r==a.activeElement&&r.select()}function o(){var e,a=this,o=t(a),d=this.id;if(""==a.value){if("password"==a.type){if(!o.data("placeholder-textinput")){try{e=o.clone().attr({type:"text"})}catch(c){e=t("<input>").attr(t.extend(l(this),{type:"text"}))}e.removeAttr("name").data({"placeholder-password":!0,"placeholder-id":d}).bind("focus.placeholder",r),o.data({"placeholder-textinput":e,"placeholder-id":d}).before(e)}o=o.removeAttr("id").hide().prev().attr("id",d).show()}o.addClass("placeholder"),o[0].value=o.attr("placeholder")}else o.removeClass("placeholder")}var d,c,n="placeholder"in a.createElement("input"),i="placeholder"in a.createElement("textarea"),h=t.fn,u=t.valHooks;n&&i?(c=h.placeholder=function(){return this},c.input=c.textarea=!0):(c=h.placeholder=function(){var e=this;return e.filter((n?"textarea":":input")+"[placeholder]").not(".placeholder").bind({"focus.placeholder":r,"blur.placeholder":o}).data("placeholder-enabled",!0).trigger("blur.placeholder"),e},c.input=n,c.textarea=i,d={get:function(e){var a=t(e);return a.data("placeholder-enabled")&&a.hasClass("placeholder")?"":e.value},set:function(e,l){var d=t(e);return d.data("placeholder-enabled")?(""==l?(e.value=l,e!=a.activeElement&&o.call(e)):d.hasClass("placeholder")?r.call(e,!0,l)||(e.value=l):e.value=l,d):e.value=l}},n||(u.input=d),i||(u.textarea=d),t(function(){t(a).delegate("form","submit.placeholder",function(){var e=t(".placeholder",this).each(r);setTimeout(function(){e.each(o)},10)})}),t(e).bind("beforeunload.placeholder",function(){t(".placeholder").each(function(){this.value=""})}))}(this,document,jQuery);

// Sticky Sidebar
!function(e){e.fn.stickySidebar=function(o){var t=e.extend({headerSelector:"header",navSelector:"nav",contentSelector:"#content",footerSelector:"footer",sidebarTopMargin:20,footerThreshold:100},o),r=function(){var o=e(this),r=e(window).height(),i=(e(window).width(),e(document).height()),n=e(t.headerSelector).outerHeight(),s=e(t.navSelector).outerHeight(),c=o.outerHeight(),h=e(t.contentSelector).outerHeight(),a=e(t.footerSelector).outerHeight(),d=e(window).scrollTop(),l=n+s,f=i-(c+a+t.footerThreshold);if(h>c&&r>c)if(l>d)o.removeClass("sticky");else if(d>=l&&f>d)o.addClass("sticky").css("top",t.sidebarTopMargin);else{var u=f-d;o.addClass("sticky").css("top",u)}};return this.each(function(){e(window).on("scroll",e.proxy(r,this)),e(window).on("resize",e.proxy(r,this)),e.proxy(r,this)()})}}(jQuery);


// Shifter
!function(e,t){"use strict";function i(i){n||(r=e.extend(r,i||{}),o.$body=e("body"),o.$shifts=e(".shifter-header, .shifter-page"),o.$nav=e(".shifter-navigation"),o.$shifts.length>0&&o.$nav.length>0&&(n=!0,o.$body.addClass("shifter").on("touchstart.shifter click.shifter",".shifter-handle",a),void 0!==t.matchMedia&&(o.mediaQuery=t.matchMedia("(max-width:"+(r.maxWidth===1/0?"100000px":r.maxWidth)+")"),o.mediaQuery.addListener(s),s())))}function s(){o.mediaQuery.matches?f.enable():f.disable()}function a(e){e.preventDefault(),e.stopPropagation(),o.$body.hasClass("shifter-open")?f.close():f.open()}var n=!1,o={},r={maxWidth:"740px"},f={close:function(){n&&($("header").removeClass("coverheader"),$("header").addClass("scrollheader"),o.$body.removeClass("shifter-open"),o.$shifts.off(".shifter"),o.$nav.find("input").trigger("blur"),$("header").removeClass("scrollheader"),$("header").addClass("coverheader"),$("header").css("left","0") )},enable:function(){n&&o.$body.addClass("shifter-active")},defaults:function(t){r=e.extend(r,t||{})},destroy:function(){n&&(o.$body.removeClass("shifter shifter-active shifter-open").off("touchstart.shifter click.shifter"),void 0!==t.matchMedia&&o.mediaQuery.removeListener(s),o={})},disable:function(){n&&o.$body.removeClass("shifter-active")},open:function(){n&&($("header").css("left","270px"),o.$body.addClass("shifter-open"),o.$shifts.one("touchstart.shifter click.shifter",a))}};e.shifter=function(e){return f[e]?f[e].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof e&&e?this:i.apply(this,arguments)}}(jQuery,window); 


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.originalEvent.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

$(document).ready(function() {
  (function() {

    $(document).on('shopify:section:load', function(event) {      
      jQuery(window).trigger('resize').trigger('scroll');

      var Heightcalculate = $('header').height(); 

      $('.no-fouc').removeClass('no-fouc');
      $('.load-wait').addClass('hide'); 

    });  

/* slick slider for product carousel site-wide */
 $(document).ready(function(){
   if ($('.collection-carousel-slick')){
     if ($('.collection-carousel-slick').length > 0 ){
    $('.collection-carousel-slick').slick({
        accessibility: false,
        slidesToShow: 6,
        infinite: false,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              arrows: true,
              slidesToShow: 5
            }
          },
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              slidesToShow: 4
            }
          },
          {
            breakpoint: 960,
            settings: {
              arrows: true,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 500,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
    });
     }
   }
}); 

var carouselCount =0;
  // ADA compliant carousel buttons
  function a11yClick(event){
      if(event.type === 'click'){
          return true;
      }
      else if(event.type === 'keypress'){
          var code = event.charCode || event.keyCode;
          if((code === 9) || (code === 13)){
              return true;
          }
      }
      else{
          return false;
      }
  }}());

}); // end doc ready


theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision =( precision===0)?0: (precision || 2);
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':        
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

     return formatString.replace(placeholderRegex, value) ;
  }

  return {
    formatMoney: formatMoney
  }
})();

   
/* ================ Sections ================ */


$(document).ready(function(){

    $("#CartDrawer").bind("click keydown mouserover touchstart mouseenter" ,function(){
      window.slideout = false;
    })

  //jQuery(window).trigger('resize').trigger('scroll');
    $('.no-fouc').removeClass('no-fouc');
    $('.load-wait').addClass('hide');
 

$.shifter({
    maxWidth: Infinity
  }); 

  // Sidebar Toggle for screens below 980px wide
  var $Sidebar = $("#sidebar");
  $(document).on("click.toggleNav touch.toggleNav", ".show", function(){ 
    $Sidebar.toggleClass("open");
  });

  if ( $(this).width() < 740 ) {
    $('ul#blog-articles').insertBefore('#blog-sidebar');
  }   
}); 


$(document).ready(function() {
  var sections = new theme.Sections();
  
  sections.register('product-section', theme.Product);
  
  sections.register('collection-section', theme.Collection);

  $('.open_search_bar').click(function(){
    var sb = $('.search_bar');
    sb.toggle("fast",null);

    if (sb.is(':visible')){
      if ($(window).width() > 979)  {
        $('.search_bar .search_drawer').focus(); 
        }
    }
    if (sb.attr('aria-expanded') === 'true') {
      sb.attr('aria-expanded', 'false');
    }
    else {
      sb.attr('aria-expanded', 'true');
    }
  });

});

function disableScrolling(){
    var x=window.scrollX;
    var y=window.scrollY;
    window.onscroll=function(){window.scrollTo(x, y);};
}
function enableScrolling(){
    window.onscroll=function(){};
}

$(".fa fa-search").click(function(){
   $(".search_bar").toggle();

});

function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds){
      break;
    }
  }
}
function applyCouponCode(couponCode){
 if (couponCode != "" ){
	$.ajax('../../discount/' + couponCode); 
 }
}
function add2BagGp(pids, couponCode, openDrawer = true){
    addJS = {items:[]};
    for (var i in pids) {
      addJS.items.push(    {
            quantity: 1,
            id: pids[i]
          });
    }
      $.post('/cart/add.js',addJS,function(){console.log("function done");},'json')
        .done(function(){
	  applyCouponCode(couponCode);
	  ajaxCart.load(openDrawer);
        });
}

function add2BagproductListing(vid,pid,sku,name,featImg = false,varName = false,price,oprice,vendor,sampleTag,event,itemGroupId ="", openDrawer = false ){
    var addJs = "";
    let variableName = varName;
    let openCartDrawer = openDrawer;
    if (varName == 'false') {
      variableName = false;
    }
    if (openDrawer == 'true') {
      openCartDrawer = true;
    }

    var properties = {};addJs ={
      quantity: 1,
      id: vid,
      properties: properties
    };

    $.post('/cart/add.js',addJs,function(){console.log("function done");},'json')
        .done(function(){
          ajaxCart.setTrigger(event);
          ajaxCart.load(openCartDrawer, pid, name, featImg, variableName)
        })
        .fail(response => {
          const errorMessage = response?.responseJSON?.message ?? ''; 
          if (errorMessage.includes('VALIDATION:')) {
              ajaxCart.load(true);
              handleValidationError(errorMessage);
          }
        });var kv_item = {
      "variant_id":vid,
      "price":price,
      "title":name,
      "sku":sku
    };
    _learnq = _learnq || [];	
 		_learnq.push(['track', 'Added to Cart', kv_item]);dataLayer.push({"event":"EEaddToCart",
    "ecommerce": {
      "currencyCode":"",
      "add": {
        "products": [{
          "id":sku,
          "sku":sku,
          "name":name,
          "productPrice":price ,
          "price":price,
          "list_price": oprice ,
          "brand":vendor,
          "category":"cosmetics",
          "variant":name, 
          "quantity":1
        }]
      }
    }
  });
}

function checkcartandadd(id,pid){  
  jsonData =  $.getJSON('/cart.js', function( data ) { 
        var add_to_cart = true; 
        for(var i of data.items){
          if (i.product_id == pid){            
            add_to_cart =false;
            break;
          }
        }
        if (add_to_cart){
          add2BagGp([id],""); 
        }
      return data});

}
function disableSample(pid){
  return true;
}

function addSample(variantID,productID){
  var mySelector =  ".smpl-" + productID;    
  $(mySelector).addClass("disabled"); 
  //$("#cart_curtan").show();
  checkcartandadd(variantID,productID);
    slideout=true;     
    ajaxCart.load();
      setTimeout(function() {
    //$("#cart_curtan").hide();
    if (slideout){ $(".js-drawer-close").click();}
    }, 3500);
}

function returnOnetrustActiveGroups(){
  var output =""
  if (typeof dataLayer  !== 'undefined'){    
    for (var i in dataLayer) { 
      if (typeof i.OnetrustActiveGroups  !== 'undefined'){    
        output=  i.OnetrustActiveGroups;
        break;
      }
    }
    return output;
  }
}

// global video functions
function playPause (el, title) {
  let video = el.parentElement.parentElement.querySelector('.video-element');
  if (video.paused) {
    video.play();
    el.classList.add('pause');
    el.classList.remove('play');
    el.setAttribute('aria-label', `Pause video of ${title}`);
  } else {
    video.pause();
    el.classList.add('play');
    el.classList.remove('pause');
    el.setAttribute('aria-label', `Play video of ${title}`);
  }
}

function muteUnmute (el, title) {
  let video = el.parentElement.parentElement.querySelector('.video-element');
  if (video.muted) {
    video.muted = false;
    el.classList.add('sound-on');
    el.classList.remove('sound-off');
    el.setAttribute('aria-label', `Mute video of ${title}`);
  } else {
    video.muted = true;
    el.classList.add('sound-off');
    el.classList.remove('sound-on');
    el.setAttribute('aria-label', `Unmute video of ${title}`);
  }
}





(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.bodyScrollLock = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  // Older browsers don't support event options, feature detect it.

  // Adopted and modified solution from Bohdan Didukh (2017)
  // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

  var hasPassiveEvents = false;
  if (typeof window !== 'undefined') {
    var passiveTestOptions = {
      get passive() {
        hasPassiveEvents = true;
        return undefined;
      }
    };
    window.addEventListener('testPassive', null, passiveTestOptions);
    window.removeEventListener('testPassive', null, passiveTestOptions);
  }

  var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


  var locks = [];
  var documentListenerAdded = false;
  var initialClientY = -1;
  var previousBodyOverflowSetting = void 0;
  var previousBodyPosition = void 0;
  var previousBodyPaddingRight = void 0;

  // returns true if `el` should be allowed to receive touchmove events.
  var allowTouchMove = function allowTouchMove(el) {
    return locks.some(function (lock) {
      if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
        return true;
      }

      return false;
    });
  };

  var preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;

    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if (allowTouchMove(e.target)) {
      return true;
    }

    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;

    if (e.preventDefault) e.preventDefault();

    return false;
  };

  var setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if (previousBodyPaddingRight === undefined) {
      var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
      var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

      if (_reserveScrollBarGap && scrollBarGap > 0) {
        var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
        previousBodyPaddingRight = document.body.style.paddingRight;
        document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
      }
    }

    // If previousBodyOverflowSetting is already set, don't set it again.
    if (previousBodyOverflowSetting === undefined) {
      previousBodyOverflowSetting = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  };

  var restoreOverflowSetting = function restoreOverflowSetting() {
    if (previousBodyPaddingRight !== undefined) {
      document.body.style.paddingRight = previousBodyPaddingRight;

      // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
      // can be set again.
      previousBodyPaddingRight = undefined;
    }

    if (previousBodyOverflowSetting !== undefined) {
      document.body.style.overflow = previousBodyOverflowSetting;

      // Restore previousBodyOverflowSetting to undefined
      // so setOverflowHidden knows it can be set again.
      previousBodyOverflowSetting = undefined;
    }
  };

  var setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function () {
      // If previousBodyPosition is already set, don't set it again.
      if (previousBodyPosition === undefined) {
        previousBodyPosition = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left
        };

        // Update the dom inside an animation frame
        var _window = window,
            scrollY = _window.scrollY,
            scrollX = _window.scrollX,
            innerHeight = _window.innerHeight;

        // body-scroll-lock removes sticky class from new-header, set positioning
        var fixedMenu = document.querySelector('.new-header');
        var endMainMenuLinks = document.querySelector('.new-header__mobile-nav');
        fixedMenu.style.position = 'fixed';

        // calculate amount scrolled if any to avoid screen jump
        const amountScrolled = window.pageYOffset;
        const announcementBarHeight = document.getElementById('shopify-section-announcement-bar')?.offsetHeight;
        let amountToTop = 0;
        if (amountScrolled < announcementBarHeight) amountToTop = announcementBarHeight - amountScrolled;
        fixedMenu.style.top = `${amountToTop}`;

        fixedMenu.style.zIndex = '1199';
        // move additional links down below last link
        

        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.left = -scrollX + 'px';

        setTimeout(function () {
          return window.requestAnimationFrame(function () {
            // Attempt to check if the bottom bar appeared due to the position change
            var bottomBarHeight = innerHeight - window.innerHeight;
            if (bottomBarHeight && scrollY >= innerHeight) {
              // Move the content further up so that the bottom bar doesn't hide it
              document.body.style.top = -(scrollY + bottomBarHeight);
            }
          });
        }, 300);
      }
    });
  };

  var restorePositionSetting = function restorePositionSetting() {
    // console.log("previous position setting " + JSON.stringify(previousBodyPosition));
    if (previousBodyPosition !== undefined) {
      // Convert the position from "px" to Int
      var y = -parseInt(document.body.style.top, 10);
      var x = -parseInt(document.body.style.left, 10);

      // Restore styles

        // body-scroll-lock removes sticky class from new-header, restore positioning
        var fixedMenu = document.querySelector('.new-header');
        fixedMenu.style.position = '';
        fixedMenu.style.top = '';

      document.body.style.position = previousBodyPosition.position;
      document.body.style.top = previousBodyPosition.top;
      document.body.style.left = previousBodyPosition.left;

      // Restore scroll
      window.scrollTo(x, y);

      previousBodyPosition = undefined;
    }
  };

  // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
  var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
  };

  var handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - initialClientY;

    if (allowTouchMove(event.target)) {
      return false;
    }

    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
      // element is at the top of its scroll.
      return preventDefault(event);
    }

    if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
      // element is at the bottom of its scroll.
      return preventDefault(event);
    }

    event.stopPropagation();
    return true;
  };

  var disableBodyScroll = exports.disableBodyScroll = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
      // eslint-disable-next-line no-console
      console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
      return;
    }

    // disableBodyScroll must not have been called on this targetElement before
    if (locks.some(function (lock) {
      return lock.targetElement === targetElement;
    })) {
      return;
    }

    var lock = {
      targetElement: targetElement,
      options: options || {}
    };

    locks = [].concat(_toConsumableArray(locks), [lock]);

    if (isIosDevice) {
      setPositionFixed();
    } else {
      setOverflowHidden(options);
    }

    if (isIosDevice) {
      targetElement.ontouchstart = function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch.
          initialClientY = event.targetTouches[0].clientY;
        }
      };
      targetElement.ontouchmove = function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch.
          handleScroll(event, targetElement);
        }
      };

      if (!documentListenerAdded) {
        document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
        documentListenerAdded = true;
      }
    }
  };

  var clearAllBodyScrollLocks = exports.clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
    if (isIosDevice) {
      // Clear all locks ontouchstart/ontouchmove handlers, and the references.
      locks.forEach(function (lock) {
        lock.targetElement.ontouchstart = null;
        lock.targetElement.ontouchmove = null;
      });

      if (documentListenerAdded) {
        document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
        documentListenerAdded = false;
      }

      // Reset initial clientY.
      initialClientY = -1;
    }

    if (isIosDevice) {
      restorePositionSetting();
    } else {
      restoreOverflowSetting();
    }

    locks = [];
  };

  var enableBodyScroll = exports.enableBodyScroll = function enableBodyScroll(targetElement) {
    if (!targetElement) {
      // eslint-disable-next-line no-console
      console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
      return;
    }

    locks = locks.filter(function (lock) {
      return lock.targetElement !== targetElement;
    });

    if (isIosDevice) {
      targetElement.ontouchstart = null;
      targetElement.ontouchmove = null;

      if (documentListenerAdded && locks.length === 0) {
        document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
        documentListenerAdded = false;
      }
    }

    if (isIosDevice) {
      restorePositionSetting();
    } else {
      restoreOverflowSetting();
    }
  };
});

const handleProductCardVariantChange = (variantId, label) => {
  const productCard = label.closest('.product-card');
  const allLabels = productCard.querySelectorAll('.variant-wrapper');
  
  for (let labelEl of allLabels) {
    if (labelEl.querySelector('.variant-highlight').style.removeProperty) {
      labelEl.querySelector('.variant-highlight').style.removeProperty('border-bottom');
    } else {
      labelEl.querySelector('.variant-highlight').style.removeAttribute('border-bottom');
    }
  }

  label.querySelector('.variant-radio').checked = true;
  
  const productImageEl = productCard.querySelector('.product-card-left img');
  const productPriceEl = productCard.querySelector('.product-card-right .product-card__product-price .product-card__product-price--promo');
  const productStrikePriceEl = productCard.querySelector('.product-card-right .product-card__product-price .product-card__product-price--compare');
  const productTitleEl = productCard.querySelector('.product-card-right .product-card__info-container .product-card__product-title');
  const variantName = label.querySelector('.variant-image-wrapper img').getAttribute('title');
  const variantNameEl = productCard.querySelector('.product-card__variant-title');
  const moneyFormat = productCard.getAttribute('data-money-format');
  
  const allCtas = productCard.querySelectorAll('[id^="product-card-cta__"]');

  for(let cta of allCtas) {
    if(cta.id.includes(variantId)) {
      cta.style.display = 'flex';
    } else {
      cta.style.display = 'none';
    }
  }

  const variantAvailable = label.getAttribute('data-available');
  const selectedVariantImage = label.getAttribute('data-vimage');
  const selectedVariantPrice = label.getAttribute('data-vprice');
  let formattedPrice = theme.Currency.formatMoney(selectedVariantPrice, moneyFormat);
  
  formattedPrice.endsWith('.00') && (formattedPrice = formattedPrice.replace('.00', ''));
  formattedPrice.endsWith(',00') && (formattedPrice = formattedPrice.replace(',00', ''));
  
  const selectedVariantCompareAtPrice = label.getAttribute('data-v-compare-at-price');
  let formattedStrikePrice = selectedVariantCompareAtPrice ?
    theme.Currency.formatMoney(selectedVariantCompareAtPrice , moneyFormat)
    : '';
    
  formattedStrikePrice.endsWith('.00') && (formattedStrikePrice = formattedStrikePrice.replace('.00', ''));
  formattedStrikePrice.endsWith(',00') && (formattedStrikePrice = formattedStrikePrice.replace(',00', ''));
    
  if (variantNameEl) {
    variantNameEl.innerText = variantName;
  }
  
  if (productTitleEl.innerText.toLowerCase().includes('lightform')) {
    let updatedProductTitle = productTitleEl.innerText.split('-')[0];
    updatedProductTitle = `${updatedProductTitle} - ${variantName}`;
    productTitleEl.innerText = updatedProductTitle;
  }

  productImageEl.srcset = selectedVariantImage;
  productImageEl.src = selectedVariantImage;

  if (productPriceEl) {
    productPriceEl.innerText = formattedPrice;
    productStrikePriceEl.innerText = formattedStrikePrice;
  }
  
  if (productCard.classList.contains('bundle-item')) {
    const bundleAddToCartBtn = document.querySelector('.pdp--bundle-items #bundleAdd');
    productCard.setAttribute('data-variant-id', variantId);
    
    if (variantAvailable == 'false') {
      productCard.setAttribute('data-product-available', false);
      if (bundleAddToCartBtn && !bundleAddToCartBtn.classList.contains('btn-disabled')) {
        bundleAddToCartBtn.classList.add('btn-disabled');
        bundleAddToCartBtn.innerText = "Sold Out";
      }
    } else {
      productCard.setAttribute('data-product-available', true);
      if (bundleAddToCartBtn && bundleAddToCartBtn.classList.contains('btn-disabled')) {
        bundleAddToCartBtn.classList.remove('btn-disabled');
        bundleAddToCartBtn.innerText = "Add to Bag";
      }
    }
  }

}

